export default __webpack_public_path__ + "static/media/google-calendar.91658c53.svg";